module.exports = __webpack_public_path__ + "static/media/baijiale_m_game.3fd407f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/baijiale_m_game.mp4
// module id = Kdb+
// module chunks = 0